// extracted by mini-css-extract-plugin
export var button = "_mi-2";
export var card = "_mi-0";
export var closeButtonContainer = "_mi-3";
export var iconContainer = "_mi-1";